'use client';

import { useState } from "react";
import { Box, Text, Flex, Image, For, Heading, Link, Avatar } from "@chakra-ui/react";
import { LuPlay } from "react-icons/lu"

export default  function ShortBox({ item }) {

  const { shortUrl } = item;

  const parsed = new URL(shortUrl);
  let videoId = '';

  if (parsed.pathname.startsWith("/embed/")) {
    videoId = parsed.pathname.split("/embed/")[1].split("?")[0];
  }

  // Caso seja formato watch?v=VIDEOID
  if (parsed.searchParams.has("v")) {
    videoId = parsed.searchParams.get("v");
  }

  // Caso seja Shorts
  if (parsed.pathname.startsWith("/shorts/")) {
    videoId = parsed.pathname.split("/shorts/")[1].split("?")[0];
  }

  const [isPlaying, setIsPlaying] = useState(false);

  const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

  return (
    <Box
      position="relative"
      w="100%"
      maxW="360px"
      h="420px"
      p="2"
      borderRadius="md"
      overflow="hidden"
      cursor="pointer"
      onClick={() => setIsPlaying(true)}
      rounded="lg"
      border="2px dashed"
      borderColor="transparent"
      _hover={{ borderColor: 'blue.500'  }}
    >
      {isPlaying ? (
        <Box
          as="iframe"
          src={embedUrl}
          width="100%"
          height="100%"
          border="0"
          allowFullScreen
          rounded="lg"
        />
      ) : (
        <>
          <Image src={thumbnail} alt="YouTube Thumbnail" w="100%" h= "100%" rounded="lg"/>
          <Box
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            bg="#FF0202"
            color="white"
            borderRadius="full"
            py="2"
            px="4"
            rounded="lg"
          >
            <Box>
              <LuPlay />
            </Box>
          </Box>
        </>
      )}
    </Box>
  )
}
